import React from 'react';
import c from 'classnames';
import numeral from 'numeral';
import Countdown, { type CountdownProps } from '../Countdown';
import s from './AdoptableCountdown.scss';

export interface Props
  extends Omit<CountdownProps, 'renderTimer' | 'endedMessage'> {
  endedMessage?: string;
}

const AdoptableCountdown: React.FC<Props> = ({
  countToDate,
  className,
  endedClassName,
  endedMessage,
  onEnd,
}) => (
  <Countdown
    className={c(s['root'], className)}
    endedClassName={c(s['ended'], endedClassName)}
    countToDate={countToDate}
    renderTimer={(d, h, m, sec) =>
      [h + d * 24, m, sec].map(n => numeral(n).format('00')).join(':')
    }
    endedMessage={endedMessage}
    onEnd={onEnd}
  />
);

AdoptableCountdown.displayName = 'AdoptableCountdown';

export default AdoptableCountdown;
